import React from "react";
import { FiMap, FiCalendar, FiClock } from "react-icons/fi";
import { AssignmentCard as Card, Label, S, I, InputShell, FieldError, Help } from "./fields";
import { localToday, localTimeNow } from "../../../utils/pickupTime";

export default function AssignmentSection({
  v,
  set,
  errors,
  readOnly,
  cityOptions,
  dutyTypes,
  categoryOptions,
  pkgs,
  onPackageChange,
}) {
  const today = localToday();

  return (
    <Card
      title="Travel Details"
      subtitle="Where and when the car is needed, and which kind of car"
      icon={<FiMap className="w-5 h-5" />}
    >
      <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
        <div className="md:col-span-1" data-field="city">
          <Label required>City</Label>
          <S value={v.city} onChange={set("city")} readOnly={readOnly} invalid={!!errors.city}>
            <option value="">-- Select City --</option>
            {cityOptions.map((c) => (
              <option key={c.value} value={c.label}>{c.label}</option>
            ))}
          </S>
          <FieldError msg={errors.city} />
        </div>

        <div className="md:col-span-1" data-field="dutyType">
          <Label required>Duty Type</Label>
          <S value={v.dutyType} onChange={set("dutyType")} readOnly={readOnly} invalid={!!errors.dutyType}>
            <option value="">-- Select --</option>
            {dutyTypes.map((d)=> <option key={d.value} value={d.value}>{d.label}</option>)}
          </S>
          <FieldError msg={errors.dutyType} />
        </div>

        {v.dutyType === "OUTSTATION" && (
          <div className="md:col-span-1" data-field="outstationType">
            <Label required>Outstation Type</Label>
            <S value={v.outstationType} onChange={set("outstationType")} readOnly={readOnly} invalid={!!errors.outstationType}>
              <option value="">-- Select --</option>
              <option value="ONE_WAY">One Way</option>
              <option value="ROUND_WAY">Round Way</option>
            </S>
            <FieldError msg={errors.outstationType} />
          </div>
        )}

        <div className="md:col-span-1" data-field="vehicleClass">
          <Label required>Vehicle Category</Label>
          <S value={v.vehicleClass} onChange={set("vehicleClass")} readOnly={readOnly} invalid={!!errors.vehicleClass}>
            <option value="">-- Select Category --</option>
            {categoryOptions.map((c) => (
              <option key={c.value} value={c.value}>{c.label}</option>
            ))}
          </S>
          <FieldError msg={errors.vehicleClass} />
          {!errors.vehicleClass && !readOnly && <Help>The exact car and driver are assigned later, from Bookings.</Help>}
        </div>

        <div className="md:col-span-1" data-field="carRequiredOn">
          <Label required>Pickup date</Label>
          <InputShell icon={<FiCalendar className="w-4 h-4" />}>
            <I
              type="date"
              value={v.carRequiredOn}
              onChange={set("carRequiredOn")}
              readOnly={readOnly}
              invalid={!!errors.carRequiredOn}
              min={readOnly ? undefined : today}
            />
          </InputShell>
          <FieldError msg={errors.carRequiredOn} />
        </div>

        <div className="md:col-span-1" data-field="carRequiredTime">
          <Label required>Pickup time</Label>
          <InputShell icon={<FiClock className="w-4 h-4" />}>
            <I
              type="time"
              value={v.carRequiredTime}
              onChange={set("carRequiredTime")}
              readOnly={readOnly}
              invalid={!!errors.carRequiredTime}
              min={!readOnly && v.carRequiredOn === today ? localTimeNow() : undefined}
            />
          </InputShell>
          <FieldError msg={errors.carRequiredTime} />
        </div>

        <div className="md:col-span-2" data-field="packageId">
          <Label required>Package</Label>
          <S value={v.packageId} onChange={onPackageChange} readOnly={readOnly} invalid={!!errors.packageId}>
            <option value="">-- Select package --</option>
            {pkgs.map((p)=> <option key={p.value} value={p.value}>{p.label}</option>)}
          </S>
          <FieldError msg={errors.packageId} />
        </div>
      </div>
    </Card>
  );
}
